import { ENTITIES, entityDef } from './balancing';
import type { ContentRole, EntityKind } from '../types';

export interface CatalogItem {
  kind: EntityKind;
  name: string;
  role: ContentRole;
}

/** Display order in the build panel. */
export const CATALOG_ORDER: EntityKind[] = [
  'starter_ride',
  'spinning_ride',
  'pirate_ship',
  'ferris_wheel',
  'roller_coaster',
  'snack_kiosk',
  'drink_kiosk',
  'bench',
  'tree',
  'lamp',
];

/** Attraction order used by the next-goal label and the progression sim. */
export const ATTRACTION_LADDER: EntityKind[] = [
  'starter_ride',
  'spinning_ride',
  'pirate_ship',
  'ferris_wheel',
  'roller_coaster',
];

export const BUILD_CATALOG: CatalogItem[] = CATALOG_ORDER.map((kind) => {
  const def = ENTITIES[kind];
  return { kind, name: def.name, role: def.role };
});

export function catalogItem(kind: EntityKind): CatalogItem {
  const item = BUILD_CATALOG.find((entry) => entry.kind === kind);
  if (!item) {
    throw new Error(`Unknown catalog kind: ${kind}`);
  }
  return item;
}

export function isIncomeKind(kind: EntityKind): boolean {
  const def = entityDef(kind);
  return def.role !== 'decoration' && (def.revenuePerTickByLevel[1] ?? 0) > 0;
}

export function purchaseCost(kind: EntityKind): number {
  return entityDef(kind).purchaseCost;
}
